import { setModalType, setTaskDetailResMsg } from '../actions/taskDetailActions';
import baseApi from '../api/baseApi';
import { sentryCaptureException } from '../utils/sentryUtils';

/***************************************** API *****************************************/
const taxesApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    uploadDepositWithdrawalData: builder.mutation({
      query: ({ taskId }) => ({
        url: 'taxes/update-user-ready-to-file',
        method: 'POST',
        body: { taskId }
      }),
      async onQueryStarted(_, { queryFulfilled, dispatch }) {
        try {
          dispatch(setModalType(null));
          await queryFulfilled;
        } catch (e) {
          sentryCaptureException(e);
          dispatch(
            setTaskDetailResMsg({
              error: e?.data?.msg || 'Error occurred',
              title: 'Error uploading deposit / withdrawal forms'
            })
          );
        }
      }
    }),
    downloadUserReturn: builder.mutation({
      query: ({ userId, year, taskId }) => ({
        url: 'taxes/generate-drake-pdf-url',
        method: 'GET',
        params: { userId, year, taskId }
      }),
      async onQueryStarted(_, { queryFulfilled, dispatch }) {
        try {
          await queryFulfilled;
        } catch (e) {
          sentryCaptureException(e);
          dispatch(setTaskDetailResMsg({ success: false, error: 'Failed to download return' }));
        }
      }
    }),
    downloadDrakeflowCsv: builder.mutation({
      query: ({ userId, year, taskId }) => ({
        url: 'taxes/drakeflow-csv',
        method: 'POST',
        body: { userId, year, taskId }
      }),
      async onQueryStarted(_, { queryFulfilled, dispatch }) {
        try {
          await queryFulfilled;
        } catch (e) {
          sentryCaptureException(e);
          dispatch(setTaskDetailResMsg({ success: false, error: 'Failed to download Drakeflow CSV' }));
        }
      }
    }),
    downloadDebitCsv: builder.mutation({
      query: ({ userId, year, taskId }) => ({
        url: 'taxes/debit-csv',
        method: 'POST',
        body: { userId, year, taskId }
      }),
      async onQueryStarted(_, { queryFulfilled, dispatch }) {
        try {
          await queryFulfilled;
        } catch (e) {
          sentryCaptureException(e);
          dispatch(setTaskDetailResMsg({ success: false, error: 'Failed to download Debit CSV' }));
        }
      }
    })
  })
});

/***************************************** HOOKS *****************************************/
export const {
  useUploadDepositWithdrawalDataMutation,
  useDownloadUserReturnMutation,
  useDownloadDrakeflowCsvMutation,
  useDownloadDebitCsvMutation
} = taxesApi;
